import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/mockData';
import { 
  Bed, BedDouble, SlidersHorizontal, Sheet, 
  Cloud, Layers, Snowflake, Sofa, Moon, Baby 
} from 'lucide-react';

const categoryIcons = {
  'mattresses': Bed,
  'bed-frames': BedDouble,
  'adjustable-bases': SlidersHorizontal,
  'bedding-sheets': Sheet,
  'pillows': Cloud,
  'mattress-toppers': Layers,
  'comforters-duvets': Snowflake,
  'blankets-throws': Sofa,
  'sleep-accessories': Moon,
  'kids-bedding': Baby,
};

const categoryColors = [
  'from-red-600 to-red-500',
  'from-rose-500 to-pink-500',
  'from-orange-500 to-amber-500',
  'from-emerald-500 to-teal-500',
  'from-sky-500 to-cyan-500',
  'from-violet-500 to-purple-500',
  'from-indigo-500 to-blue-500',
  'from-fuchsia-500 to-pink-500',
  'from-slate-600 to-slate-500',
  'from-amber-500 to-yellow-500',
];

const CategoryGrid = () => {
  return (
    <section className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Browse by Category
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Find the best deals across all your favorite shopping categories
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {categories.map((category, index) => {
            const linkPath = `/category/${category.slug}`;
            
            const IconComponent = categoryIcons[category.slug] || Bed;
            const colorClass = categoryColors[index % categoryColors.length];
            
            return (
              <Link
                key={category.id}
                to={linkPath}
                className="group relative bg-slate-50 rounded-2xl p-6 text-center hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-red-200 animate-fadeInUp opacity-0"
                style={{ animationDelay: `${index * 0.03}s`, animationFillMode: 'forwards' }}
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${colorClass} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg`}>
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <span className="text-slate-700 font-semibold group-hover:text-red-600 transition-colors block">
                  {category.name}
                </span>
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-red-600/0 to-red-600/0 group-hover:from-red-600/5 group-hover:to-red-600/5 transition-all duration-300"></div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
